import { EVENTS } from '../utils/constants.js'
import makeLogin from '../applications/makeLogin.js'

class OnLoginFormSubmitted {
  static register(context) {
    context.events.handle(EVENTS.LOGIN_FORM_SUBMITTED, async payload => {
      try {
        await makeLogin(context, payload)
      } catch (error) {
        console.log('🚀 ~ OnLoginFormSubmitted ~ register ~ error:', error)
        context.sendBugAlert(error)
      }
    })
  }
}
export default OnLoginFormSubmitted
